var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInAppNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "InApp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InApp"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Push-Copy",
    transform: "translate(43.4146, 20)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3379791,1.46296296 C36.5355261,1.46296296 39.1358885,4.08751852 39.1358885,7.31481481 L39.1358885,71.6851852 C39.1358885,74.9124815 36.5355261,77.537037 33.3379791,77.537037 L7.24738676,77.537037 C4.04983972,77.537037 1.44947735,74.9124815 1.44947735,71.6851852 L1.44947735,7.31481481 C1.44947735,4.08751852 4.04983972,1.46296296 7.24738676,1.46296296 L33.3379791,1.46296296 Z M33.3379791,0 L7.24738676,0 C3.26132404,0 0,3.29166667 0,7.31481481 L0,71.6851852 C0,75.7083333 3.26132404,79 7.24738676,79 L33.3379791,79 C37.3240418,79 40.5853659,75.7083333 40.5853659,71.6851852 L40.5853659,7.31481481 C40.5853659,3.29166667 37.3240418,0 33.3379791,0 Z",
    id: "Shape",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#37474F",
    points: "17.3937282 2.92592593 23.1916376 2.92592593 23.1916376 4.38888889 17.3937282 4.38888889"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BBCADF",
    x: 5.80139373,
    y: 16.4583333,
    width: 29,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3E8F0",
    x: 10.1219512,
    y: 47.9328704,
    width: 13,
    height: 2.92592593
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3E8F0",
    x: 9.8989547,
    y: 53.9328704,
    width: 21.7421603,
    height: 2.92592593
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A1AFC3",
    x: 54,
    y: 42,
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAppNew);
export default __webpack_public_path__ + "static/media/InApp_new.5661bad3b9f44da50f6287849a5a33a1.svg";
export { ForwardRef as ReactComponent };